import React from 'react';
import { Link } from 'react-router-dom';
import LogoOnlyRemovedBG from '../images/LogoOnlyRemovedBG.png';
import Dropy2 from './UI/Dropy2';
import LinkC from './UI/LinkC';

const Navbar = ({ toggle }) => (
  <nav
    className='h-12 bg-gray-100 shadow-sm flex flex-wrap justify-between lg:justify-center nav px-4 lg:mx-0 font-semibold subpixel-antialiased'
    role='navigation'>
    <div className='flex items-center space-x-2 xl:space-x-4 xl:space-x-8 nav'>
      <Link to='/' className='flex lg:mx-4 xl:ml-20 2xl:ml-44 2xl:mr-2 logo'>
        <img src={LogoOnlyRemovedBG} alt='Logo' className='py-1 flex-shrink-0	' height='3rem' width='40rem' />
        <p className='tnt my-auto xs:inline md:hidden xl:inline mr-4'>רשת דירוגים</p>
      </Link>

      <LinkC to='/'>בית</LinkC>
      <LinkC to='/about'>אודותינו</LinkC>
      <LinkC to='/energy-efficiency'>התייעלות אנרגטית</LinkC>
      <LinkC to='/energy-storage'>אגירת אנרגיה</LinkC>
      <LinkC to='/funding'>מידע ומימון</LinkC>
      <LinkC to='/environment'>איכות הסביבה</LinkC>

      <LinkC to='/contact'>צרו קשר</LinkC>
    </div>

    <Dropy2 />
  </nav>
);

export default Navbar;
